// Category Themes Configuration
// Each theme contains 10 colors for various UI elements
// Monochromatic themes (same color shades) are listed first (40 themes)
// Multi-color themes are listed after (16 themes)
// Total: 56 themes
// Version: 2.0 - Updated with 40 monochromatic themes

export const categoryThemes = {
  // ========== MONOCHROMATIC THEMES (Same Color Shades) ==========
  // These themes use variations of a single color family
  blue: {
    name: 'Ocean Blue',
    colors: {
      primary: '#3b82f6',
      primaryLight: '#dbeafe',
      primaryDark: '#1e40af',
      secondary: '#60a5fa',
      accent: '#93c5fd',
      border: '#bfdbfe',
      text: '#1e3a8a',
      textLight: '#3b82f6',
      background: '#eff6ff',
      hover: '#2563eb'
    }
  },
  green: {
    name: 'Forest Green',
    colors: {
      primary: '#10b981',
      primaryLight: '#d1fae5',
      primaryDark: '#047857',
      secondary: '#34d399',
      accent: '#6ee7b7',
      border: '#a7f3d0',
      text: '#064e3b',
      textLight: '#10b981',
      background: '#ecfdf5',
      hover: '#059669'
    }
  },
  purple: {
    name: 'Royal Purple',
    colors: {
      primary: '#8b5cf6',
      primaryLight: '#ede9fe',
      primaryDark: '#6d28d9',
      secondary: '#a78bfa',
      accent: '#c4b5fd',
      border: '#ddd6fe',
      text: '#5b21b6',
      textLight: '#8b5cf6',
      background: '#f5f3ff',
      hover: '#7c3aed'
    }
  },
  red: {
    name: 'Crimson Red',
    colors: {
      primary: '#ef4444',
      primaryLight: '#fee2e2',
      primaryDark: '#b91c1c',
      secondary: '#f87171',
      accent: '#fca5a5',
      border: '#fecaca',
      text: '#991b1b',
      textLight: '#ef4444',
      background: '#fef2f2',
      hover: '#dc2626'
    }
  },
  orange: {
    name: 'Sunset Orange',
    colors: {
      primary: '#f97316',
      primaryLight: '#ffedd5',
      primaryDark: '#c2410c',
      secondary: '#fb923c',
      accent: '#fdba74',
      border: '#fed7aa',
      text: '#9a3412',
      textLight: '#f97316',
      background: '#fff7ed',
      hover: '#ea580c'
    }
  },
  amber: {
    name: 'Golden Amber',
    colors: {
      primary: '#f59e0b',
      primaryLight: '#fef3c7',
      primaryDark: '#b45309',
      secondary: '#fbbf24',
      accent: '#fcd34d',
      border: '#fde68a',
      text: '#78350f',
      textLight: '#f59e0b',
      background: '#fffbeb',
      hover: '#d97706'
    }
  },
  teal: {
    name: 'Ocean Teal',
    colors: {
      primary: '#14b8a6',
      primaryLight: '#ccfbf1',
      primaryDark: '#0f766e',
      secondary: '#2dd4bf',
      accent: '#5eead4',
      border: '#99f6e4',
      text: '#134e4a',
      textLight: '#14b8a6',
      background: '#f0fdfa',
      hover: '#0d9488'
    }
  },
  pink: {
    name: 'Rose Pink',
    colors: {
      primary: '#ec4899',
      primaryLight: '#fce7f3',
      primaryDark: '#be185d',
      secondary: '#f472b6',
      accent: '#f9a8d4',
      border: '#fbcfe8',
      text: '#9f1239',
      textLight: '#ec4899',
      background: '#fdf2f8',
      hover: '#db2777'
    }
  },
  indigo: {
    name: 'Deep Indigo',
    colors: {
      primary: '#6366f1',
      primaryLight: '#e0e7ff',
      primaryDark: '#4338ca',
      secondary: '#818cf8',
      accent: '#a5b4fc',
      border: '#c7d2fe',
      text: '#312e81',
      textLight: '#6366f1',
      background: '#eef2ff',
      hover: '#4f46e5'
    }
  },
  cyan: {
    name: 'Sky Cyan',
    colors: {
      primary: '#06b6d4',
      primaryLight: '#cffafe',
      primaryDark: '#0891b2',
      secondary: '#22d3ee',
      accent: '#67e8f9',
      border: '#a5f3fc',
      text: '#164e63',
      textLight: '#06b6d4',
      background: '#ecfeff',
      hover: '#0891b2'
    }
  },
  emerald: {
    name: 'Emerald Green',
    colors: {
      primary: '#059669',
      primaryLight: '#d1fae5',
      primaryDark: '#047857',
      secondary: '#10b981',
      accent: '#34d399',
      border: '#6ee7b7',
      text: '#064e3b',
      textLight: '#059669',
      background: '#ecfdf5',
      hover: '#047857'
    }
  },
  violet: {
    name: 'Violet Purple',
    colors: {
      primary: '#7c3aed',
      primaryLight: '#ede9fe',
      primaryDark: '#5b21b6',
      secondary: '#8b5cf6',
      accent: '#a78bfa',
      border: '#c4b5fd',
      text: '#4c1d95',
      textLight: '#7c3aed',
      background: '#f5f3ff',
      hover: '#6d28d9'
    }
  },
  rose: {
    name: 'Blush Rose',
    colors: {
      primary: '#f43f5e',
      primaryLight: '#ffe4e6',
      primaryDark: '#be123c',
      secondary: '#fb7185',
      accent: '#fda4af',
      border: '#fecdd3',
      text: '#9f1239',
      textLight: '#f43f5e',
      background: '#fff1f2',
      hover: '#e11d48'
    }
  },
  lime: {
    name: 'Fresh Lime',
    colors: {
      primary: '#84cc16',
      primaryLight: '#f7fee7',
      primaryDark: '#65a30d',
      secondary: '#a3e635',
      accent: '#bef264',
      border: '#d9f99d',
      text: '#365314',
      textLight: '#84cc16',
      background: '#f7fee7',
      hover: '#65a30d'
    }
  },
  sky: {
    name: 'Clear Sky',
    colors: {
      primary: '#0ea5e9',
      primaryLight: '#e0f2fe',
      primaryDark: '#0369a1',
      secondary: '#38bdf8',
      accent: '#7dd3fc',
      border: '#bae6fd',
      text: '#0c4a6e',
      textLight: '#0ea5e9',
      background: '#f0f9ff',
      hover: '#0284c7'
    }
  },
  fuchsia: {
    name: 'Vibrant Fuchsia',
    colors: {
      primary: '#d946ef',
      primaryLight: '#fae8ff',
      primaryDark: '#a21caf',
      secondary: '#e879f9',
      accent: '#f0abfc',
      border: '#f5d0fe',
      text: '#86198f',
      textLight: '#d946ef',
      background: '#fdf4ff',
      hover: '#c026d3'
    }
  },
  slate: {
    name: 'Cool Slate',
    colors: {
      primary: '#64748b',
      primaryLight: '#f1f5f9',
      primaryDark: '#475569',
      secondary: '#94a3b8',
      accent: '#cbd5e1',
      border: '#e2e8f0',
      text: '#334155',
      textLight: '#64748b',
      background: '#f8fafc',
      hover: '#475569'
    }
  },
  stone: {
    name: 'Warm Stone',
    colors: {
      primary: '#78716c',
      primaryLight: '#fafaf9',
      primaryDark: '#57534e',
      secondary: '#a8a29e',
      accent: '#d6d3d1',
      border: '#e7e5e4',
      text: '#44403c',
      textLight: '#78716c',
      background: '#fafaf9',
      hover: '#57534e'
    }
  },
  zinc: {
    name: 'Neutral Zinc',
    colors: {
      primary: '#71717a',
      primaryLight: '#fafafa',
      primaryDark: '#52525b',
      secondary: '#a1a1aa',
      accent: '#d4d4d8',
      border: '#e4e4e7',
      text: '#3f3f46',
      textLight: '#71717a',
      background: '#fafafa',
      hover: '#52525b'
    }
  },
  neutral: {
    name: 'Classic Neutral',
    colors: {
      primary: '#737373',
      primaryLight: '#fafafa',
      primaryDark: '#525252',
      secondary: '#a3a3a3',
      accent: '#d4d4d4',
      border: '#e5e5e5',
      text: '#404040',
      textLight: '#737373',
      background: '#fafafa',
      hover: '#525252'
    }
  },
  yellow: {
    name: 'Sunshine Yellow',
    colors: {
      primary: '#eab308',
      primaryLight: '#fef9c3',
      primaryDark: '#a16207',
      secondary: '#facc15',
      accent: '#fde047',
      border: '#fef08a',
      text: '#713f12',
      textLight: '#eab308',
      background: '#fefce8',
      hover: '#ca8a04'
    }
  },
  brown: {
    name: 'Rich Brown',
    colors: {
      primary: '#a16207',
      primaryLight: '#fef3c7',
      primaryDark: '#78350f',
      secondary: '#d97706',
      accent: '#f59e0b',
      border: '#fbbf24',
      text: '#451a03',
      textLight: '#a16207',
      background: '#fefce8',
      hover: '#92400e'
    }
  },
  mint: {
    name: 'Fresh Mint',
    colors: {
      primary: '#10b981',
      primaryLight: '#d1fae5',
      primaryDark: '#047857',
      secondary: '#34d399',
      accent: '#6ee7b7',
      border: '#a7f3d0',
      text: '#064e3b',
      textLight: '#10b981',
      background: '#ecfdf5',
      hover: '#059669'
    }
  },
  coral: {
    name: 'Coral Reef',
    colors: {
      primary: '#f97316',
      primaryLight: '#ffedd5',
      primaryDark: '#c2410c',
      secondary: '#fb923c',
      accent: '#fdba74',
      border: '#fed7aa',
      text: '#9a3412',
      textLight: '#f97316',
      background: '#fff7ed',
      hover: '#ea580c'
    }
  },
  lavender: {
    name: 'Soft Lavender',
    colors: {
      primary: '#a78bfa',
      primaryLight: '#f3e8ff',
      primaryDark: '#7c3aed',
      secondary: '#c4b5fd',
      accent: '#ddd6fe',
      border: '#e9d5ff',
      text: '#6b21a8',
      textLight: '#a78bfa',
      background: '#faf5ff',
      hover: '#9333ea'
    }
  },
  turquoise: {
    name: 'Tropical Turquoise',
    colors: {
      primary: '#14b8a6',
      primaryLight: '#ccfbf1',
      primaryDark: '#0f766e',
      secondary: '#2dd4bf',
      accent: '#5eead4',
      border: '#99f6e4',
      text: '#134e4a',
      textLight: '#14b8a6',
      background: '#f0fdfa',
      hover: '#0d9488'
    }
  },
  maroon: {
    name: 'Deep Maroon',
    colors: {
      primary: '#991b1b',
      primaryLight: '#fee2e2',
      primaryDark: '#7f1d1d',
      secondary: '#dc2626',
      accent: '#ef4444',
      border: '#fca5a5',
      text: '#450a0a',
      textLight: '#991b1b',
      background: '#fef2f2',
      hover: '#b91c1c'
    }
  },
  navy: {
    name: 'Navy Blue',
    colors: {
      primary: '#1e3a8a',
      primaryLight: '#dbeafe',
      primaryDark: '#1e40af',
      secondary: '#3b82f6',
      accent: '#60a5fa',
      border: '#93c5fd',
      text: '#1e293b',
      textLight: '#1e3a8a',
      background: '#eff6ff',
      hover: '#2563eb'
    }
  },
  // Additional monochromatic themes
  sapphire: {
    name: 'Sapphire Blue',
    colors: {
      primary: '#2563eb',
      primaryLight: '#dbeafe',
      primaryDark: '#1e40af',
      secondary: '#3b82f6',
      accent: '#60a5fa',
      border: '#93c5fd',
      text: '#1e3a8a',
      textLight: '#2563eb',
      background: '#eff6ff',
      hover: '#1d4ed8'
    }
  },
  forest: {
    name: 'Forest Green',
    colors: {
      primary: '#15803d',
      primaryLight: '#dcfce7',
      primaryDark: '#166534',
      secondary: '#22c55e',
      accent: '#4ade80',
      border: '#86efac',
      text: '#14532d',
      textLight: '#15803d',
      background: '#f0fdf4',
      hover: '#16a34a'
    }
  },
  jade: {
    name: 'Jade Green',
    colors: {
      primary: '#0d9488',
      primaryLight: '#ccfbf1',
      primaryDark: '#0f766e',
      secondary: '#14b8a6',
      accent: '#2dd4bf',
      border: '#5eead4',
      text: '#134e4a',
      textLight: '#0d9488',
      background: '#f0fdfa',
      hover: '#14b8a6'
    }
  },
  ruby: {
    name: 'Ruby Red',
    colors: {
      primary: '#dc2626',
      primaryLight: '#fee2e2',
      primaryDark: '#b91c1c',
      secondary: '#ef4444',
      accent: '#f87171',
      border: '#fca5a5',
      text: '#991b1b',
      textLight: '#dc2626',
      background: '#fef2f2',
      hover: '#b91c1c'
    }
  },
  tangerine: {
    name: 'Tangerine Orange',
    colors: {
      primary: '#ea580c',
      primaryLight: '#ffedd5',
      primaryDark: '#c2410c',
      secondary: '#f97316',
      accent: '#fb923c',
      border: '#fdba74',
      text: '#9a3412',
      textLight: '#ea580c',
      background: '#fff7ed',
      hover: '#c2410c'
    }
  },
  gold: {
    name: 'Pure Gold',
    colors: {
      primary: '#d97706',
      primaryLight: '#fef3c7',
      primaryDark: '#b45309',
      secondary: '#f59e0b',
      accent: '#fbbf24',
      border: '#fcd34d',
      text: '#78350f',
      textLight: '#d97706',
      background: '#fffbeb',
      hover: '#b45309'
    }
  },
  plum: {
    name: 'Deep Plum',
    colors: {
      primary: '#9333ea',
      primaryLight: '#f3e8ff',
      primaryDark: '#7c3aed',
      secondary: '#a78bfa',
      accent: '#c4b5fd',
      border: '#ddd6fe',
      text: '#6b21a8',
      textLight: '#9333ea',
      background: '#faf5ff',
      hover: '#7c3aed'
    }
  },
  magenta: {
    name: 'Vivid Magenta',
    colors: {
      primary: '#c026d3',
      primaryLight: '#fae8ff',
      primaryDark: '#a21caf',
      secondary: '#d946ef',
      accent: '#e879f9',
      border: '#f0abfc',
      text: '#86198f',
      textLight: '#c026d3',
      background: '#fdf4ff',
      hover: '#a21caf'
    }
  },
  cerulean: {
    name: 'Cerulean Blue',
    colors: {
      primary: '#0284c7',
      primaryLight: '#e0f2fe',
      primaryDark: '#0369a1',
      secondary: '#0ea5e9',
      accent: '#38bdf8',
      border: '#7dd3fc',
      text: '#0c4a6e',
      textLight: '#0284c7',
      background: '#f0f9ff',
      hover: '#0369a1'
    }
  },
  olive: {
    name: 'Olive Green',
    colors: {
      primary: '#65a30d',
      primaryLight: '#f7fee7',
      primaryDark: '#4d7c0f',
      secondary: '#84cc16',
      accent: '#a3e635',
      border: '#bef264',
      text: '#365314',
      textLight: '#65a30d',
      background: '#f7fee7',
      hover: '#4d7c0f'
    }
  },
  burgundy: {
    name: 'Burgundy Red',
    colors: {
      primary: '#7f1d1d',
      primaryLight: '#fee2e2',
      primaryDark: '#991b1b',
      secondary: '#b91c1c',
      accent: '#dc2626',
      border: '#ef4444',
      text: '#450a0a',
      textLight: '#7f1d1d',
      background: '#fef2f2',
      hover: '#991b1b'
    }
  },
  charcoal: {
    name: 'Charcoal Gray',
    colors: {
      primary: '#374151',
      primaryLight: '#f3f4f6',
      primaryDark: '#1f2937',
      secondary: '#4b5563',
      accent: '#6b7280',
      border: '#9ca3af',
      text: '#111827',
      textLight: '#374151',
      background: '#f9fafb',
      hover: '#1f2937'
    }
  },
  // ========== SINGLE SHADE THEMES (Exact Same Color) ==========
  // These themes use the EXACT same color for all properties
  solidBlue: {
    name: 'Solid Blue',
    colors: {
      primary: '#3b82f6',
      primaryLight: '#3b82f6',
      primaryDark: '#3b82f6',
      secondary: '#3b82f6',
      accent: '#3b82f6',
      border: '#3b82f6',
      text: '#3b82f6',
      textLight: '#3b82f6',
      background: '#3b82f6',
      hover: '#3b82f6'
    }
  },
  solidGreen: {
    name: 'Solid Green',
    colors: {
      primary: '#10b981',
      primaryLight: '#10b981',
      primaryDark: '#10b981',
      secondary: '#10b981',
      accent: '#10b981',
      border: '#10b981',
      text: '#10b981',
      textLight: '#10b981',
      background: '#10b981',
      hover: '#10b981'
    }
  },
  solidPurple: {
    name: 'Solid Purple',
    colors: {
      primary: '#8b5cf6',
      primaryLight: '#8b5cf6',
      primaryDark: '#8b5cf6',
      secondary: '#8b5cf6',
      accent: '#8b5cf6',
      border: '#8b5cf6',
      text: '#8b5cf6',
      textLight: '#8b5cf6',
      background: '#8b5cf6',
      hover: '#8b5cf6'
    }
  },
  solidRed: {
    name: 'Solid Red',
    colors: {
      primary: '#ef4444',
      primaryLight: '#ef4444',
      primaryDark: '#ef4444',
      secondary: '#ef4444',
      accent: '#ef4444',
      border: '#ef4444',
      text: '#ef4444',
      textLight: '#ef4444',
      background: '#ef4444',
      hover: '#ef4444'
    }
  },
  solidOrange: {
    name: 'Solid Orange',
    colors: {
      primary: '#f97316',
      primaryLight: '#f97316',
      primaryDark: '#f97316',
      secondary: '#f97316',
      accent: '#f97316',
      border: '#f97316',
      text: '#f97316',
      textLight: '#f97316',
      background: '#f97316',
      hover: '#f97316'
    }
  },
  solidAmber: {
    name: 'Solid Amber',
    colors: {
      primary: '#f59e0b',
      primaryLight: '#f59e0b',
      primaryDark: '#f59e0b',
      secondary: '#f59e0b',
      accent: '#f59e0b',
      border: '#f59e0b',
      text: '#f59e0b',
      textLight: '#f59e0b',
      background: '#f59e0b',
      hover: '#f59e0b'
    }
  },
  solidTeal: {
    name: 'Solid Teal',
    colors: {
      primary: '#14b8a6',
      primaryLight: '#14b8a6',
      primaryDark: '#14b8a6',
      secondary: '#14b8a6',
      accent: '#14b8a6',
      border: '#14b8a6',
      text: '#14b8a6',
      textLight: '#14b8a6',
      background: '#14b8a6',
      hover: '#14b8a6'
    }
  },
  solidPink: {
    name: 'Solid Pink',
    colors: {
      primary: '#ec4899',
      primaryLight: '#ec4899',
      primaryDark: '#ec4899',
      secondary: '#ec4899',
      accent: '#ec4899',
      border: '#ec4899',
      text: '#ec4899',
      textLight: '#ec4899',
      background: '#ec4899',
      hover: '#ec4899'
    }
  },
  solidIndigo: {
    name: 'Solid Indigo',
    colors: {
      primary: '#6366f1',
      primaryLight: '#6366f1',
      primaryDark: '#6366f1',
      secondary: '#6366f1',
      accent: '#6366f1',
      border: '#6366f1',
      text: '#6366f1',
      textLight: '#6366f1',
      background: '#6366f1',
      hover: '#6366f1'
    }
  },
  solidCyan: {
    name: 'Solid Cyan',
    colors: {
      primary: '#06b6d4',
      primaryLight: '#06b6d4',
      primaryDark: '#06b6d4',
      secondary: '#06b6d4',
      accent: '#06b6d4',
      border: '#06b6d4',
      text: '#06b6d4',
      textLight: '#06b6d4',
      background: '#06b6d4',
      hover: '#06b6d4'
    }
  },
  solidEmerald: {
    name: 'Solid Emerald',
    colors: {
      primary: '#059669',
      primaryLight: '#059669',
      primaryDark: '#059669',
      secondary: '#059669',
      accent: '#059669',
      border: '#059669',
      text: '#059669',
      textLight: '#059669',
      background: '#059669',
      hover: '#059669'
    }
  },
  solidViolet: {
    name: 'Solid Violet',
    colors: {
      primary: '#7c3aed',
      primaryLight: '#7c3aed',
      primaryDark: '#7c3aed',
      secondary: '#7c3aed',
      accent: '#7c3aed',
      border: '#7c3aed',
      text: '#7c3aed',
      textLight: '#7c3aed',
      background: '#7c3aed',
      hover: '#7c3aed'
    }
  },
  solidRose: {
    name: 'Solid Rose',
    colors: {
      primary: '#f43f5e',
      primaryLight: '#f43f5e',
      primaryDark: '#f43f5e',
      secondary: '#f43f5e',
      accent: '#f43f5e',
      border: '#f43f5e',
      text: '#f43f5e',
      textLight: '#f43f5e',
      background: '#f43f5e',
      hover: '#f43f5e'
    }
  },
  solidLime: {
    name: 'Solid Lime',
    colors: {
      primary: '#84cc16',
      primaryLight: '#84cc16',
      primaryDark: '#84cc16',
      secondary: '#84cc16',
      accent: '#84cc16',
      border: '#84cc16',
      text: '#84cc16',
      textLight: '#84cc16',
      background: '#84cc16',
      hover: '#84cc16'
    }
  },
  solidSky: {
    name: 'Solid Sky',
    colors: {
      primary: '#0ea5e9',
      primaryLight: '#0ea5e9',
      primaryDark: '#0ea5e9',
      secondary: '#0ea5e9',
      accent: '#0ea5e9',
      border: '#0ea5e9',
      text: '#0ea5e9',
      textLight: '#0ea5e9',
      background: '#0ea5e9',
      hover: '#0ea5e9'
    }
  },
  solidFuchsia: {
    name: 'Solid Fuchsia',
    colors: {
      primary: '#d946ef',
      primaryLight: '#d946ef',
      primaryDark: '#d946ef',
      secondary: '#d946ef',
      accent: '#d946ef',
      border: '#d946ef',
      text: '#d946ef',
      textLight: '#d946ef',
      background: '#d946ef',
      hover: '#d946ef'
    }
  },
  solidYellow: {
    name: 'Solid Yellow',
    colors: {
      primary: '#eab308',
      primaryLight: '#eab308',
      primaryDark: '#eab308',
      secondary: '#eab308',
      accent: '#eab308',
      border: '#eab308',
      text: '#eab308',
      textLight: '#eab308',
      background: '#eab308',
      hover: '#eab308'
    }
  },
  solidBrown: {
    name: 'Solid Brown',
    colors: {
      primary: '#a16207',
      primaryLight: '#a16207',
      primaryDark: '#a16207',
      secondary: '#a16207',
      accent: '#a16207',
      border: '#a16207',
      text: '#a16207',
      textLight: '#a16207',
      background: '#a16207',
      hover: '#a16207'
    }
  },
  solidNavy: {
    name: 'Solid Navy',
    colors: {
      primary: '#1e3a8a',
      primaryLight: '#1e3a8a',
      primaryDark: '#1e3a8a',
      secondary: '#1e3a8a',
      accent: '#1e3a8a',
      border: '#1e3a8a',
      text: '#1e3a8a',
      textLight: '#1e3a8a',
      background: '#1e3a8a',
      hover: '#1e3a8a'
    }
  },
  solidMaroon: {
    name: 'Solid Maroon',
    colors: {
      primary: '#991b1b',
      primaryLight: '#991b1b',
      primaryDark: '#991b1b',
      secondary: '#991b1b',
      accent: '#991b1b',
      border: '#991b1b',
      text: '#991b1b',
      textLight: '#991b1b',
      background: '#991b1b',
      hover: '#991b1b'
    }
  },
  solidSlate: {
    name: 'Solid Slate',
    colors: {
      primary: '#64748b',
      primaryLight: '#64748b',
      primaryDark: '#64748b',
      secondary: '#64748b',
      accent: '#64748b',
      border: '#64748b',
      text: '#64748b',
      textLight: '#64748b',
      background: '#64748b',
      hover: '#64748b'
    }
  },
  solidGray: {
    name: 'Solid Gray',
    colors: {
      primary: '#6b7280',
      primaryLight: '#6b7280',
      primaryDark: '#6b7280',
      secondary: '#6b7280',
      accent: '#6b7280',
      border: '#6b7280',
      text: '#6b7280',
      textLight: '#6b7280',
      background: '#6b7280',
      hover: '#6b7280'
    }
  },
  solidBlack: {
    name: 'Solid Black',
    colors: {
      primary: '#000000',
      primaryLight: '#000000',
      primaryDark: '#000000',
      secondary: '#000000',
      accent: '#000000',
      border: '#000000',
      text: '#000000',
      textLight: '#000000',
      background: '#000000',
      hover: '#000000'
    }
  },
  solidWhite: {
    name: 'Solid White',
    colors: {
      primary: '#ffffff',
      primaryLight: '#ffffff',
      primaryDark: '#ffffff',
      secondary: '#ffffff',
      accent: '#ffffff',
      border: '#ffffff',
      text: '#ffffff',
      textLight: '#ffffff',
      background: '#ffffff',
      hover: '#ffffff'
    }
  },
  solidLavender: {
    name: 'Solid Lavender',
    colors: {
      primary: '#a78bfa',
      primaryLight: '#a78bfa',
      primaryDark: '#a78bfa',
      secondary: '#a78bfa',
      accent: '#a78bfa',
      border: '#a78bfa',
      text: '#a78bfa',
      textLight: '#a78bfa',
      background: '#a78bfa',
      hover: '#a78bfa'
    }
  },
  solidTurquoise: {
    name: 'Solid Turquoise',
    colors: {
      primary: '#14b8a6',
      primaryLight: '#14b8a6',
      primaryDark: '#14b8a6',
      secondary: '#14b8a6',
      accent: '#14b8a6',
      border: '#14b8a6',
      text: '#14b8a6',
      textLight: '#14b8a6',
      background: '#14b8a6',
      hover: '#14b8a6'
    }
  },
  solidCoral: {
    name: 'Solid Coral',
    colors: {
      primary: '#f97316',
      primaryLight: '#f97316',
      primaryDark: '#f97316',
      secondary: '#f97316',
      accent: '#f97316',
      border: '#f97316',
      text: '#f97316',
      textLight: '#f97316',
      background: '#f97316',
      hover: '#f97316'
    }
  },
  solidMagenta: {
    name: 'Solid Magenta',
    colors: {
      primary: '#c026d3',
      primaryLight: '#c026d3',
      primaryDark: '#c026d3',
      secondary: '#c026d3',
      accent: '#c026d3',
      border: '#c026d3',
      text: '#c026d3',
      textLight: '#c026d3',
      background: '#c026d3',
      hover: '#c026d3'
    }
  },
  solidOlive: {
    name: 'Solid Olive',
    colors: {
      primary: '#65a30d',
      primaryLight: '#65a30d',
      primaryDark: '#65a30d',
      secondary: '#65a30d',
      accent: '#65a30d',
      border: '#65a30d',
      text: '#65a30d',
      textLight: '#65a30d',
      background: '#65a30d',
      hover: '#65a30d'
    }
  },
  solidGold: {
    name: 'Solid Gold',
    colors: {
      primary: '#d97706',
      primaryLight: '#d97706',
      primaryDark: '#d97706',
      secondary: '#d97706',
      accent: '#d97706',
      border: '#d97706',
      text: '#d97706',
      textLight: '#d97706',
      background: '#d97706',
      hover: '#d97706'
    }
  },
  solidPlum: {
    name: 'Solid Plum',
    colors: {
      primary: '#9333ea',
      primaryLight: '#9333ea',
      primaryDark: '#9333ea',
      secondary: '#9333ea',
      accent: '#9333ea',
      border: '#9333ea',
      text: '#9333ea',
      textLight: '#9333ea',
      background: '#9333ea',
      hover: '#9333ea'
    }
  },
  solidRuby: {
    name: 'Solid Ruby',
    colors: {
      primary: '#dc2626',
      primaryLight: '#dc2626',
      primaryDark: '#dc2626',
      secondary: '#dc2626',
      accent: '#dc2626',
      border: '#dc2626',
      text: '#dc2626',
      textLight: '#dc2626',
      background: '#dc2626',
      hover: '#dc2626'
    }
  },
  solidSapphire: {
    name: 'Solid Sapphire',
    colors: {
      primary: '#2563eb',
      primaryLight: '#2563eb',
      primaryDark: '#2563eb',
      secondary: '#2563eb',
      accent: '#2563eb',
      border: '#2563eb',
      text: '#2563eb',
      textLight: '#2563eb',
      background: '#2563eb',
      hover: '#2563eb'
    }
  },
  solidJade: {
    name: 'Solid Jade',
    colors: {
      primary: '#0d9488',
      primaryLight: '#0d9488',
      primaryDark: '#0d9488',
      secondary: '#0d9488',
      accent: '#0d9488',
      border: '#0d9488',
      text: '#0d9488',
      textLight: '#0d9488',
      background: '#0d9488',
      hover: '#0d9488'
    }
  },
  // ========== MULTI-COLOR THEMES (Random/Mixed Colors) ==========
  // These themes use multiple different colors
  sunset: {
    name: 'Sunset',
    colors: {
      primary: '#f97316',
      primaryLight: '#fff1e6',
      primaryDark: '#c2410c',
      secondary: '#ec4899',
      accent: '#f59e0b',
      border: '#fbbf24',
      text: '#9a3412',
      textLight: '#f97316',
      background: '#fff7ed',
      hover: '#ea580c'
    }
  },
  ocean: {
    name: 'Ocean Waves',
    colors: {
      primary: '#06b6d4',
      primaryLight: '#e0f7fa',
      primaryDark: '#0891b2',
      secondary: '#3b82f6',
      accent: '#14b8a6',
      border: '#67e8f9',
      text: '#164e63',
      textLight: '#06b6d4',
      background: '#ecfeff',
      hover: '#0891b2'
    }
  },
  tropical: {
    name: 'Tropical',
    colors: {
      primary: '#ec4899',
      primaryLight: '#fce7f3',
      primaryDark: '#be185d',
      secondary: '#f97316',
      accent: '#eab308',
      border: '#f9a8d4',
      text: '#9f1239',
      textLight: '#ec4899',
      background: '#fdf2f8',
      hover: '#db2777'
    }
  },
  royal: {
    name: 'Royal',
    colors: {
      primary: '#7c3aed',
      primaryLight: '#ede9fe',
      primaryDark: '#5b21b6',
      secondary: '#f59e0b',
      accent: '#3b82f6',
      border: '#c4b5fd',
      text: '#4c1d95',
      textLight: '#7c3aed',
      background: '#f5f3ff',
      hover: '#6d28d9'
    }
  },
  berry: {
    name: 'Berry',
    colors: {
      primary: '#d946ef',
      primaryLight: '#fae8ff',
      primaryDark: '#a21caf',
      secondary: '#ec4899',
      accent: '#f43f5e',
      border: '#f5d0fe',
      text: '#86198f',
      textLight: '#d946ef',
      background: '#fdf4ff',
      hover: '#c026d3'
    }
  },
  citrus: {
    name: 'Citrus',
    colors: {
      primary: '#84cc16',
      primaryLight: '#f7fee7',
      primaryDark: '#65a30d',
      secondary: '#eab308',
      accent: '#f97316',
      border: '#bef264',
      text: '#365314',
      textLight: '#84cc16',
      background: '#f7fee7',
      hover: '#65a30d'
    }
  },
  aurora: {
    name: 'Aurora',
    colors: {
      primary: '#6366f1',
      primaryLight: '#e0e7ff',
      primaryDark: '#4338ca',
      secondary: '#8b5cf6',
      accent: '#ec4899',
      border: '#a5b4fc',
      text: '#312e81',
      textLight: '#6366f1',
      background: '#eef2ff',
      hover: '#4f46e5'
    }
  },
  fire: {
    name: 'Fire',
    colors: {
      primary: '#ef4444',
      primaryLight: '#fee2e2',
      primaryDark: '#b91c1c',
      secondary: '#f97316',
      accent: '#f59e0b',
      border: '#fca5a5',
      text: '#991b1b',
      textLight: '#ef4444',
      background: '#fef2f2',
      hover: '#dc2626'
    }
  },
  oceanBreeze: {
    name: 'Ocean Breeze',
    colors: {
      primary: '#14b8a6',
      primaryLight: '#ccfbf1',
      primaryDark: '#0f766e',
      secondary: '#06b6d4',
      accent: '#3b82f6',
      border: '#5eead4',
      text: '#134e4a',
      textLight: '#14b8a6',
      background: '#f0fdfa',
      hover: '#0d9488'
    }
  },
  spring: {
    name: 'Spring',
    colors: {
      primary: '#10b981',
      primaryLight: '#d1fae5',
      primaryDark: '#047857',
      secondary: '#ec4899',
      accent: '#eab308',
      border: '#6ee7b7',
      text: '#064e3b',
      textLight: '#10b981',
      background: '#ecfdf5',
      hover: '#059669'
    }
  },
  autumn: {
    name: 'Autumn',
    colors: {
      primary: '#f97316',
      primaryLight: '#ffedd5',
      primaryDark: '#c2410c',
      secondary: '#dc2626',
      accent: '#a16207',
      border: '#fdba74',
      text: '#9a3412',
      textLight: '#f97316',
      background: '#fff7ed',
      hover: '#ea580c'
    }
  },
  rainbow: {
    name: 'Rainbow',
    colors: {
      primary: '#8b5cf6',
      primaryLight: '#f3e8ff',
      primaryDark: '#6d28d9',
      secondary: '#ec4899',
      accent: '#f59e0b',
      border: '#c4b5fd',
      text: '#5b21b6',
      textLight: '#8b5cf6',
      background: '#faf5ff',
      hover: '#7c3aed'
    }
  },
  mintChocolate: {
    name: 'Mint Chocolate',
    colors: {
      primary: '#10b981',
      primaryLight: '#d1fae5',
      primaryDark: '#047857',
      secondary: '#78716c',
      accent: '#a16207',
      border: '#6ee7b7',
      text: '#064e3b',
      textLight: '#10b981',
      background: '#ecfdf5',
      hover: '#059669'
    }
  },
  midnight: {
    name: 'Midnight',
    colors: {
      primary: '#6366f1',
      primaryLight: '#e0e7ff',
      primaryDark: '#4338ca',
      secondary: '#8b5cf6',
      accent: '#1e3a8a',
      border: '#a5b4fc',
      text: '#312e81',
      textLight: '#6366f1',
      background: '#eef2ff',
      hover: '#4f46e5'
    }
  },
  peach: {
    name: 'Peach',
    colors: {
      primary: '#fb923c',
      primaryLight: '#fff1e6',
      primaryDark: '#c2410c',
      secondary: '#f97316',
      accent: '#ec4899',
      border: '#fed7aa',
      text: '#9a3412',
      textLight: '#fb923c',
      background: '#fff7ed',
      hover: '#f97316'
    }
  },
  roseGold: {
    name: 'Rose Gold',
    colors: {
      primary: '#f43f5e',
      primaryLight: '#ffe4e6',
      primaryDark: '#be123c',
      secondary: '#f59e0b',
      accent: '#fb923c',
      border: '#fda4af',
      text: '#9f1239',
      textLight: '#f43f5e',
      background: '#fff1f2',
      hover: '#e11d48'
    }
  }
};

// Get theme by name
export const getTheme = (themeName = 'blue') => {
  return categoryThemes[themeName] || categoryThemes.blue;
};

// Get all theme names
export const getThemeNames = () => {
  return Object.keys(categoryThemes);
};

// Get random color variation from theme for card variety
export const getCardThemeVariation = (theme, index = 0) => {
  const colorKeys = ['primary', 'secondary', 'accent', 'primaryDark', 'hover'];
  const backgroundKeys = ['background', 'primaryLight', 'border'];
  const textKeys = ['text', 'textLight', 'primary'];
  
  // Use index to cycle through colors (deterministic but varied)
  const borderColorKey = colorKeys[index % colorKeys.length];
  const backgroundColorKey = backgroundKeys[index % backgroundKeys.length];
  const textColorKey = textKeys[index % textKeys.length];
  const badgeBgKey = backgroundKeys[(index + 1) % backgroundKeys.length];
  const badgeColorKey = colorKeys[index % colorKeys.length];
  
  return {
    borderColor: theme.colors[borderColorKey] || theme.colors.primary,
    backgroundColor: theme.colors[backgroundColorKey] || theme.colors.background,
    textColor: theme.colors[textColorKey] || theme.colors.text,
    textLightColor: theme.colors.textLight || theme.colors.primary,
    badgeBackground: theme.colors[badgeBgKey] || theme.colors.primaryLight,
    badgeColor: theme.colors[badgeColorKey] || theme.colors.primary,
    hoverColor: theme.colors.hover || theme.colors.primary
  };
};
